/**
 * Enhances the patrols data by adding a patrolCountAtLocationString property to each patrol.
 * @param patrols - The patrols to enhance.
 * @returns The enhanced patrols.
 */ export function enhancePatrolData(
	patrols: ScheduleAssignment[],
): ScheduleAssignment[] {
	// Step 1: Count combinations
	const countMap = new Map();

	patrols.forEach((patrol) => {
		const key = `${patrol.cust_id}-${patrol.address_id}`;
		if (!countMap.has(key)) {
			countMap.set(key, { count: 0, index: 0 });
		}
		const entry = countMap.get(key);
		entry.count++;
		countMap.set(key, entry);
	});

	// Step 2: Map to new array with patrolCountAtLocationString
	return patrols.map((patrol) => {
		const key = `${patrol.cust_id}-${patrol.address_id}`;
		const entry = countMap.get(key);
		entry.index++;
		const patrolCountAtLocationString = `${entry.index} of ${entry.count}`;

		// Returning a new object with all original patrol properties + patrolCountAtLocationString
		return {
			...patrol,
			patrolCountAtLocationString,
		};
	});
}
